







































































import { Component, Vue } from "vue-property-decorator";
import { isPhoneNumber } from "@/utils/utils";
import { validations, rejectLogin } from "@/api/api.config";
@Component
export default class register extends Vue {
  checked = false;
  text = "获取验证码";
  count: any = null;
  time: any = null;
  phone = "";
  isShow = false;
  code = "";
  addBtnPasword(): any {
    this.setInterValFunc();
  }
  setInterValFunc() {
    let Time_out = 60;
    if (this.time) return;
    if (isPhoneNumber(this.phone)) {
      this.count = Time_out;
      // 请求接口
      validations(this.phone);
      this.time = setInterval(() => {
        if (this.count > 0 && this.count <= Time_out) {
          let timeouts = this.count--;
          this.text = `重新获取${timeouts}s`;
        } else {
          clearInterval(this.time);
          this.time = null;
          this.text = "获取验证码";
        }
      }, 1000);
    } else {
      this.$toast.fail("手机号错误");
    }
  }
  // 注册
  registered() {
    if (!isPhoneNumber(this.phone)) {
      this.$toast.fail("手机号错误");
      return;
    }
    // if (this.password != this.password1) {
    //   this.$toast.fail("密码输入不一致请重新输入");
    //   return;
    // }
    if (!this.checked) {
      this.$toast.fail("请勾选我已阅读并同意");
      return;
    }

    if (!this.code.trim()) {
      this.$toast.fail("请输入验证码");
      return;
    }

    let { code, phone } = this;
    rejectLogin({ phone: phone, code: code })
      .then((res) => {
        if (res.status === 200) {
          this.$toast.success("注册成功");
          this.$router.push({
            path: "/login",
          });
        } else if (res.status === 400) {
          return this.$toast.fail("验证码错误");
        }
      })
      .catch((err) => {
        this.$toast.fail("验证码错误");
      });
    this.$toast.success("注册成功");
    this.$router.push({
      path: "/home",
    });
  }
  //事件
  changews(e: any) {
    if (e.target.value) {
      this.isShow = true;
    }
  }
  // 清除
  deletes() {
    this.phone = "";
    this.isShow = false;
  }
}
